import { render, staticRenderFns } from "./familia.vue?vue&type=template&id=1a85eebd&scoped=true"
import script from "./familia.vue?vue&type=script&lang=js"
export * from "./familia.vue?vue&type=script&lang=js"
import style0 from "./familia.vue?vue&type=style&index=0&id=1a85eebd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85eebd",
  null
  
)

export default component.exports